import React from 'react';
import { Calculator } from 'lucide-react';
import { CalculationRule } from '../../types';

interface CalculationBadgeProps {
  calculations: CalculationRule[];
  calculatedValues: Record<string, any>;
}

export const CalculationBadge: React.FC<CalculationBadgeProps> = ({
  calculations,
  calculatedValues,
}) => {
  if (!calculations || calculations.length === 0) return null;

  return (
    <div
      style={{
        background: 'linear-gradient(135deg, rgba(2, 132, 199, 0.15) 0%, rgba(16, 185, 129, 0.15) 100%)',
        border: '1px solid rgba(56, 189, 248, 0.3)',
        borderRadius: 'var(--radius-md)',
        padding: '18px 20px',
        marginBottom: '24px',
      }}
    >
      <div style={{ display: 'flex', alignItems: 'center', gap: '8px', fontSize: '13px', fontWeight: 700, color: 'var(--accent-blue)', textTransform: 'uppercase', marginBottom: '12px' }}>
        <Calculator size={16} />
        <span>Automatic Calculations (Pure Mathematics)</span>
      </div>

      {calculations.map((calc) => {
        const displayVal = calculatedValues[`${calc.id}_display`];
        const rawPct = calculatedValues[calc.id];

        if (rawPct === undefined) {
          return (
            <div key={calc.id} style={{ fontSize: '13px', color: 'var(--text-dim)' }}>
              {calc.label}: Enter required counts above to calculate percentage.
            </div>
          );
        }

        return (
          <div
            key={calc.id}
            style={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'space-between',
              background: 'rgba(2, 6, 23, 0.6)',
              padding: '12px 16px',
              borderRadius: 'var(--radius-sm)',
              border: '1px solid var(--border-color)',
            }}
          >
            <div>
              <div style={{ fontSize: '13px', color: 'var(--text-muted)', fontWeight: 500 }}>
                {calc.label}
              </div>
              <div style={{ fontSize: '12px', color: 'var(--text-dim)', fontFamily: 'var(--font-mono)' }}>
                {displayVal}
              </div>
            </div>

            <div
              style={{
                fontSize: '24px',
                fontWeight: 800,
                color: 'var(--accent-blue)',
                fontFamily: 'var(--font-mono)',
              }}
            >
              {rawPct}%
            </div>
          </div>
        );
      })}
    </div>
  );
};
